import { render, staticRenderFns } from "./GlobalRoles.vue?vue&type=template&id=1d3dfe66&scoped=true"
import script from "./GlobalRoles.vue?vue&type=script&lang=js"
export * from "./GlobalRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3dfe66",
  null
  
)

export default component.exports